import { render, staticRenderFns } from "./orderServicerUnderway.vue?vue&type=template&id=8a75d18e&"
import script from "./orderServicerUnderway.vue?vue&type=script&lang=ts&"
export * from "./orderServicerUnderway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports